import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import {
  SessionServerSelectors,
  SessionSiteSelectors,
  SessionUserSelectors
} from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { isSelfServiceSchedulingEnabledForAllContentTypes } from '~src/schedule/utils/ScheduleUtils';
import { siteCountAndCloudAdminStatusRequest } from '~src/siteManagement/actions/SiteCountAndCloudAdminStatusAction';
import { NavLocationSelectors } from '~src/spacesPlatform/selectors/NavigationStateSelectors';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { selectCatalogingOnSiteEnabled } from '../../../catalog/selectors/CatalogSelectors';
import { NavPanel, NavPanelDispatchProps, NavPanelOwnProps, NavPanelStateProps } from './NavPanel';

const mapStateToProps: MapStateToProps<NavPanelStateProps> = (state: AppState) => ({
  siteUrls: siteUrlsSelector(state),
  spaceType: state.spaceInfo.spaceType,
  currentNavLocation: NavLocationSelectors.selectNavLocation(state),
  inServerArea: NavLocationSelectors.inServerArea(state),
  doesTheServerHaveMoreThanOneSite: SessionServerSelectors.doesTheServerHaveMoreThanOneSite(state),
  isSessionSiteAdmin: SessionSiteSelectors.isSessionSiteAdmin(state),
  isSessionServerAdmin: SessionUserSelectors.isSessionServerAdmin(state),
  isSiteAdminSettingsEnabled: SessionServerSelectors.isSiteAdminSettingsEnabled(state),
  isAdminViewsEnabled: SessionServerSelectors.isAdminViewsEnabled(state),
  isCatalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state),
  isNamedSharingEnabled: SessionSiteSelectors.isNamedSharingEnabled(state),
  isVizRecommendationsEnabled: SessionSiteSelectors.isVizRecommendationsEnabled(state),
  shouldShowPersonalSpace: SessionSiteSelectors.shouldShowPersonalSpace(state),
  isSitePickerEnabled: SessionServerSelectors.sitePickerEnabled(state),
  isCustomDomainEnabled: state.customDomainEnabled,
  isSchedulesPageHidden: isSelfServiceSchedulingEnabledForAllContentTypes(),
  isGroupSetsEnabled: SessionSiteSelectors.isGroupSetsEnabledForSite(state),
  siteCountAndCloudAdminStatus: state.siteCountAndCloudAdminStatus,
  canPublish: SessionSiteSelectors.isSessionCanPublish(state)
});

const mapDispatchToProps: MapDispatchToProps<NavPanelDispatchProps> =
  (dispatch) => bindActionCreators({
    requestSiteCountAndCloudAdminStatus: siteCountAndCloudAdminStatusRequest
  },
  dispatch);

export const ConnectedNavPanel: React.ComponentClass<NavPanelOwnProps> =
  connect(mapStateToProps, mapDispatchToProps)(NavPanel);
